import { css, html } from 'react-strict-dom';
import { Style } from 'src/constants';

import { Text } from '../../../components';

type Props = {
  title: string;
  /** The line under the title, e.g. "Dream Car Giveaways · Community Overhaul". */
  meta: string;
  /** The order's own reference, shown beside the title as "#2026-006". */
  reference?: string | null;
};

/**
 * The title block of a Service Order screen: name and reference above, the
 * client and project the work belongs to below.
 */
export default function ServiceOrderPageHeader({
  title,
  meta,
  reference,
}: Props) {
  return (
    <html.div style={[Style.col, styles.wrap]}>
      <html.div style={[Style.row, Style.alignCenter, styles.titleRow]}>
        <Text
          typeface="headline"
          color="neutral100"
          as="h1"
          style={styles.title}
        >
          {title}
        </Text>
        {reference && (
          <Text typeface="body.medium" color="neutral60">
            {`#${reference}`}
          </Text>
        )}
      </html.div>
      <html.div style={[Style.row, Style.alignCenter, styles.metaRow]}>
        <Text typeface="caption.medium" color="neutral60">
          {meta}
        </Text>
      </html.div>
    </html.div>
  );
}

const styles = css.create({
  wrap: {
    gap: 4,
  },
  titleRow: {
    gap: 8,
    flexWrap: 'wrap',
  },
  title: {
    minWidth: 0,
  },
  metaRow: {
    gap: 6,
  },
});
